type Point = { x: number; y: number };
const epsilon = 1e-9;
const cross = (a: Point, b: Point, c: Point) => (b.x-a.x)*(c.y-a.y)-(b.y-a.y)*(c.x-a.x);
const onEdge = (a: Point, b: Point, p: Point) => Math.abs(cross(a,b,p)) <= epsilon &&
  p.x >= Math.min(a.x,b.x)-epsilon && p.x <= Math.max(a.x,b.x)+epsilon &&
  p.y >= Math.min(a.y,b.y)-epsilon && p.y <= Math.max(a.y,b.y)+epsilon;

/** Bounded simple polygons only. Concavity and either winding are supported;
 * crossings, self-touching outlines and repeated vertices are not solids. */
export function isSimpleVisualOutline(points: readonly Point[]): boolean {
  let area = 0;
  for (let i=0;i<points.length;i++) {
    const a=points[i],b=points[(i+1)%points.length];
    area += a.x*b.y-b.x*a.y;
    for(let j=i+1;j<points.length;j++) {
      if(Math.hypot(a.x-points[j].x,a.y-points[j].y)<1e-6)return false;
      if(j===i+1 || (i===0 && j===points.length-1))continue;
      const c=points[j],d=points[(j+1)%points.length];
      if(onEdge(a,b,c)||onEdge(a,b,d)||onEdge(c,d,a)||onEdge(c,d,b)||
        (cross(a,b,c)*cross(a,b,d)<0 && cross(c,d,a)*cross(c,d,b)<0))return false;
    }
  }
  return Math.abs(area)>1e-8;
}
